import React, { isValidElement, cloneElement, HTMLAttributes } from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'

const StyledExpertModeButton = styled.button`
  ${tw`flex items-center justify-center gap-4 border-3 border-dark-gray-700 px-8 h-[38px] rounded-18 text-14 text-dark-gray-100 hover:text-primary`}
  background: ${({ theme }) => theme.colors.gradients.accent};
`

interface ExpertModeProps extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  text?: string
  onClick?: () => any
}

export default function ExpertModeButton({ children, text, onClick, ...rest }: ExpertModeProps) {
  return (
    <StyledExpertModeButton
      onClick={() => {
        if (onClick) {
          onClick()
        }
      }}
      {...rest}
    >
      {isValidElement(children) && cloneElement(children)}
      {text}
    </StyledExpertModeButton>
  )
}
